import { CustomTextField, SampleCheckbox, SingleFormBoxScene, SingleTableBoxScene } from "@/shared/components/ui";
import { ArrowBack } from '@mui/icons-material';
import { useNavigate, useParams } from "react-router-dom";
import { gridSizeMdLg12, ROUTER_PATHS } from "@/shared";
import { toast } from "react-toastify";
import { useFetchActivityTypeById, useUpdateActivityType } from "../../actions/noc-module.actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ActivityType } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import * as yup from 'yup';
import { useEffect } from "react";
import { Grid } from "@mui/material";
import { queryClient } from "@/shared/query-client/query-client";

type SaveFormData = Omit<ActivityType, 'idActivityType'>;

export default function ParametrosTipoActividadEditarPage() {

    let { id } = useParams();

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoParametrosPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocParametrosNav;

    const useUpdateActivityTypeMutation = useUpdateActivityType(id);

    const {
        data: activityTypeRes,
    } = useFetchActivityTypeById({
        idActivityType: id
    }) as any;

    const newActivityTypeSchema = yup.object({
        nameActivityType: yup.string().required('Nombre de la actividad requerido'),
    });

    const form = useForm<SaveFormData>({
        resolver: yupResolver(newActivityTypeSchema as any),
        defaultValues: {
            nameActivityType: '',
            statusActivityType: false
        },
    });

    const {
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = form;

    useEffect(() => {
        const wr = activityTypeRes as any;
        if (wr?.data) {
            form.reset(wr.data);
        }
    }, [activityTypeRes, form]);

    const onSave = () => {
        if (!isValid) return;

        useUpdateActivityTypeMutation.mutate(form.getValues(), {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['activityType'] });
                navigate(returnUrlOrdenTrabajoParametrosPage);
                toast.success("Tipo Actividad actualizada correctamente")
            },
            onError: (error: any) => {
                console.error('Error al actualizar el Tipo Actividad:', error);
                toast.error('Error al actualizar el Tipo Actividad');
            }
        });
    };

    return (
        <>
            <SingleTableBoxScene
                title={"Editar Tipo de Actividad"}
                textRedirect={"Atras"}
                iconRedirect={<ArrowBack />}
                urlRedirect={`${returnUrlOrdenTrabajoParametrosPage}`}
                visibleReport={true}
            >

                <SingleFormBoxScene
                    titlePage={""}
                    onCancel={() => {
                        navigate(returnUrlOrdenTrabajoParametrosPage);
                    }}
                    containerMaxWidth={"sm"}
                    py={6}
                    onSave={handleSubmit(onSave)}
                >

                    <CustomTextField
                        label="Nombre Tipo de Actividad"
                        name="nameActivityType"
                        control={control}
                        defaultValue={form.getValues().nameActivityType || ''}
                        error={errors.nameActivityType}
                        helperText={errors.nameActivityType?.message ?? ''}
                        size={gridSizeMdLg12}
                    />

                    <Grid item {...gridSizeMdLg12}>
                        <SampleCheckbox
                            label="Estado Tipo Actividad"
                            name="statusActivityType"
                            control={control}
                            defaultValue={!!form.getValues().statusActivityType || false}
                            // textNote={"Obligatoriedad para instalación de Cajas / Naps"}
                            isState
                        />
                    </Grid>

                </SingleFormBoxScene>
            </SingleTableBoxScene>
        </>
    )
}